import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11 * (props.wx ?? 1)}
    height={35 * (props.hx ?? 1)}
    viewBox="0 0 11 35"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.591 23.299a7.2 7.2 0 0 0-.334-1.356c-.247-.684-.479-1.37-.582-2.089-.207-1.442-.51-3.063-.78-4.93-.372-2.58-.675-5.635-1.146-9.345C6.411 2.908 5.532 1 4.92 1c-.647 0-.827 1.458-1.083 4.426-.514 5.972-1.117 10.908-1.5 14.19-.12 1.03-.31 2.05-.677 3.02a7 7 0 0 0-.358 1.29c-.425 2.572-.343 6.354-.104 8.619.063.594.36.856 1.312.98 2.07.27 4.993.207 6.513.045.681-.073 1.016-.415 1.01-1.313-.01-1.645-.114-6.757-.44-8.958"
    />
  </svg>
);
export default SvgNormal;
